// extracted by mini-css-extract-plugin
export default {"header":"OrderComments_header__9fQpJ","editor":"OrderComments_editor__vWOqj","saveButton":"OrderComments_saveButton__KHHER","editor-text":"OrderComments_editor-text__K2Ju3"};